import {Condition} from '@legit.health/ui';
import {Avatar} from '@mui/material';

const avatarSx = {
  height: 56,
  width: 56,
  mr: 2,
  bgcolor: 'primary.main'
};

export default function ConditionAvatar({condition}: {condition: Condition}) {
  const firstImage = condition.getFirstImageThumbnail();
  return firstImage ? (
    <Avatar variant="rounded" sx={avatarSx} src={firstImage} />
  ) : (
    <Avatar variant="rounded" sx={avatarSx}>
      {condition.pathology.name.charAt(0)}
    </Avatar>
  );
}
